export default __webpack_public_path__ + "static/media/QS.cc68ac97.svg";